import { IExponentialBackOffOptions } from '../interface/types'
import { IDelay } from './types'

export abstract class Delay implements IDelay {
  protected attempt = 0
  constructor(private options: IExponentialBackOffOptions) {}

  public apply() {
    return new Promise(resolve => setTimeout(resolve, this.delay))
  }

  public setAttemptNumber(attempt: number) {
    this.attempt = attempt
  }

  private get delay() {
    const constant = this.options.startingDelay
    const base = this.options.exponentialTime
    const power = this.numOfDelayedAttempts
    const delay = constant * Math.pow(base, power)

    return Math.min(delay, this.options.maximumDelay)
  }

  protected get numOfDelayedAttempts() {
    return this.attempt
  }
}
